// extracted by mini-css-extract-plugin
export default {"headerContainer":"AnimatedRoutes_headerContainer__NBePd"};